import { render, staticRenderFns } from "./WxUserName.vue?vue&type=template&id=76590690&scoped=true"
import script from "./WxUserName.vue?vue&type=script&lang=js"
export * from "./WxUserName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76590690",
  null
  
)

export default component.exports